import { render } from "./AlertasStockList.vue?vue&type=template&id=1685119e&scoped=true"
import script from "./AlertasStockList.vue?vue&type=script&lang=js"
export * from "./AlertasStockList.vue?vue&type=script&lang=js"

import "./AlertasStockList.vue?vue&type=style&index=0&id=1685119e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1685119e"]])

export default __exports__